import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import HitakariHouse from "@/pages/HitakariHouse";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#F5EEDF",
              color: "#17402A",
              border: "1px solid #78846B",
              borderRadius: 0,
              fontFamily: "'Nunito Sans', sans-serif",
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HitakariHouse />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<Article />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
